<div>
    {{ 'selected-service' | translate }} {{ categoryName }} {{ 'in-date' | translate }}
    <span *ngIf="ticketReservation.reservationTime">{{ displayReservationTime | date:'dd/MM/yyyy' }}</span>
    <span *ngIf="ticketReservation.reservationTime && ticketReservation.isTimeSelected"> {{ displayReservationTime | date:'HH:mm' }}</span>
</div>
<button (click)="makeReservation()" class="btn btn-primary" [disabled]="invalidReservation() || formSubmitted">
    {{ 'reserve' | translate }}<span *ngIf="formSubmitted" class="spinner-border spinner-border-sm my-1" role="status"
    aria-hidden="true"></span>
</button>
<div *ngIf="invalidReservation()" class="text-danger">{{ 'complete-all-fields-correctly' | translate }}</div>    
